// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts"
// @generated from file gitpod/v1/insights.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { DisableProjectInsightsRequest, DisableProjectInsightsResponse, EnableProjectInsightsRequest, EnableProjectInsightsResponse, GetAgentTraceStatsRequest, GetAgentTraceStatsResponse, GetCoAuthorStatsRequest, GetCoAuthorStatsResponse, GetInsightsSummaryRequest, GetInsightsSummaryResponse, GetProjectInsightsStatusRequest, GetProjectInsightsStatusResponse, GetPrStatsSummaryRequest, GetPrStatsSummaryResponse, ReportAgentTraceRequest, ReportAgentTraceResponse, ReportCoAuthorStatsRequest, ReportCoAuthorStatsResponse, ReportPrStatsRequest, ReportPrStatsResponse } from "./insights_pb.js";
import { MethodIdempotency, MethodKind } from "@bufbuild/protobuf";

/**
 * InsightsService provides AI code attribution analytics for projects.
 * The CLI reports per-commit co-author data from git history, and the
 * dashboard reads aggregated stats.
 *
 * @generated from service gitpod.v1.InsightsService
 */
export const InsightsService = {
  typeName: "gitpod.v1.InsightsService",
  methods: {
    /**
     * Reports co-author analysis results from a project's git history.
     * Accepts a batch of per-commit stats. Writes are idempotent: re-reporting
     * the same commit (project_id + commit_hash) overwrites the previous row.
     *
     * @generated from rpc gitpod.v1.InsightsService.ReportCoAuthorStats
     */
    reportCoAuthorStats: {
      name: "ReportCoAuthorStats",
      I: ReportCoAuthorStatsRequest,
      O: ReportCoAuthorStatsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Returns aggregated co-author stats for a project within a date range.
     *
     * Aggregates per-commit data into summary cards (totals per tool) and
     * time-series buckets at the requested resolution.
     *
     * @generated from rpc gitpod.v1.InsightsService.GetCoAuthorStats
     */
    getCoAuthorStats: {
      name: "GetCoAuthorStats",
      I: GetCoAuthorStatsRequest,
      O: GetCoAuthorStatsResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Enables co-author insights for a project. Idempotent.
     *
     * @generated from rpc gitpod.v1.InsightsService.EnableProjectInsights
     */
    enableProjectInsights: {
      name: "EnableProjectInsights",
      I: EnableProjectInsightsRequest,
      O: EnableProjectInsightsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Disables co-author insights for a project. Idempotent.
     * Removes the associated workflow (if any) and sets enabled to false.
     *
     * @generated from rpc gitpod.v1.InsightsService.DisableProjectInsights
     */
    disableProjectInsights: {
      name: "DisableProjectInsights",
      I: DisableProjectInsightsRequest,
      O: DisableProjectInsightsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Returns whether co-author insights is enabled for a project.
     *
     * @generated from rpc gitpod.v1.InsightsService.GetProjectInsightsStatus
     */
    getProjectInsightsStatus: {
      name: "GetProjectInsightsStatus",
      I: GetProjectInsightsStatusRequest,
      O: GetProjectInsightsStatusResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Reports PR speed metrics collected from SCM APIs.
     * Accepts a batch of per-PR stats. Writes are idempotent: re-reporting
     * the same PR (project_id + pr_number) overwrites the previous row.
     *
     * @generated from rpc gitpod.v1.InsightsService.ReportPrStats
     */
    reportPrStats: {
      name: "ReportPrStats",
      I: ReportPrStatsRequest,
      O: ReportPrStatsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Returns a summary of PR speed metrics for a project within a date range.
     *
     * Returns all four scalar metrics (lead time, PRs merged, time to first
     * approval, deployment frequency), their trends vs. the previous period,
     * and a sparkline for the project home card.
     *
     * @generated from rpc gitpod.v1.InsightsService.GetPrStatsSummary
     */
    getPrStatsSummary: {
      name: "GetPrStatsSummary",
      I: GetPrStatsSummaryRequest,
      O: GetPrStatsSummaryResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Reports an agent trace session for a project environment.
     * Stores the raw trace alongside denormalized line-change totals.
     *
     * @generated from rpc gitpod.v1.InsightsService.ReportAgentTrace
     */
    reportAgentTrace: {
      name: "ReportAgentTrace",
      I: ReportAgentTraceRequest,
      O: ReportAgentTraceResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Returns aggregated agent trace stats for a project within a date range.
     *
     * Aggregates per-session data into summary totals and time-series buckets
     * at the requested resolution.
     *
     * @generated from rpc gitpod.v1.InsightsService.GetAgentTraceStats
     */
    getAgentTraceStats: {
      name: "GetAgentTraceStats",
      I: GetAgentTraceStatsRequest,
      O: GetAgentTraceStatsResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * Returns how many projects have insights enabled vs total projects in the org.
     *
     * @generated from rpc gitpod.v1.InsightsService.GetInsightsSummary
     */
    getInsightsSummary: {
      name: "GetInsightsSummary",
      I: GetInsightsSummaryRequest,
      O: GetInsightsSummaryResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
  }
} as const;

